<template>
  <div>
    <b-card>
      <div class="mb-4 pb-3 border-bottom">
        <h4 class="mb-3">Bulk Update Fields</h4>
        <h5 class="text-muted">Unit No. <b-badge variant="vb-secondary" class="mx-1"
            v-for="(item, index) in selectedCids" :key="index">{{ item.unit_number }}</b-badge></h5>
        <label class="small font-weight-bold">Select the fields you wish to update for the selected listings:</label>
        <multiselect v-model="selectedFields" :options="fieldOptions" :multiple="true" :close-on-select="false"
          :clear-on-select="true" placeholder="Type or select fields (e.g. Plan Name, Price...)" label="label"
          track-by="id">
        </multiselect>
      </div>

      <b-form @submit.prevent="mlsUpload">
        <div class="row">
          <b-col cols="12" v-if="isFieldSelected('planName')">
            <b-form-group label="Plan Name:" label-for="upload-list-plan-name">
              <b-form-input v-model="uploadForm.planName" id="upload-list-plan-name"
                placeholder="Enter Plan Name"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="md-6" v-if="isFieldSelected('bed')">
            <b-form-group label="Beds:">
              <b-form-input v-model="uploadForm.bed" placeholder="e.g. 2"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="md-6" v-if="isFieldSelected('bath')">
            <b-form-group label="Baths:">
              <b-form-input v-model="uploadForm.bath" placeholder="e.g. 2"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="md-6" v-if="isFieldSelected('unitSize')">
            <b-form-group label="Unit Size (Sqft):">
              <b-form-input v-model="uploadForm.unitSize" placeholder="Enter Sqft"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="md-6" v-if="isFieldSelected('actualSize')">
            <b-form-group label="Actual Size (Sqft):">
              <b-form-input v-model="uploadForm.actualSize" placeholder="Enter Sqft"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="md-3" v-if="isFieldSelected('balcony')">
            <b-form-group label="Balcony:">
              <b-form-input v-model="uploadForm.balcony" placeholder="e.g. 1"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="md-3" v-if="isFieldSelected('balcony_area')">
            <b-form-group label="Balcony Area:">
              <b-form-input v-model="uploadForm.balcony_area" placeholder="e.g. 50"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" v-if="isFieldSelected('fp')">
            <b-form-group label="FP Specs:">
              <multiselect v-model="uploadForm.fp" :options="mlsFP" :multiple="true" label="name" track-by="value"
                placeholder="Select Specs"></multiselect>
            </b-form-group>
          </b-col>

          <b-col cols="md-6" v-if="isFieldSelected('orientation')">
            <b-form-group label="View Orientation:">
              <b-form-select v-model="uploadForm.orientation" :options="mlsOrientation"></b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="md-6" v-if="isFieldSelected('fl')">
            <b-form-group label="Floor Level:">
              <b-form-select v-model="uploadForm.fl" :options="mlsFloorLevel"></b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="md-6" v-if="isFieldSelected('stalls')">
            <b-form-group label="Parking:">
              <b-form-select v-model="uploadForm.stalls" :options="mlsParking"></b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="md-6" v-if="isFieldSelected('backupfile')">
            <b-form-group label="Backup File:">
              <FileUploadCell :row="uploadForm.backupfile" @file-selected="handleBackupFile" />
            </b-form-group>
          </b-col>

          <b-col cols="md-6" v-if="isFieldSelected('mls_parking')">
            <b-form-group label="Stalls:">
              <b-form-input type="number" v-model="uploadForm.mls_parking"
                placeholder="Number of stalls"></b-form-input>
            </b-form-group>
          </b-col>


          <b-col cols="md-6" v-if="isFieldSelected('listDate')">
            <b-form-group label="List Date:">
              <b-form-datepicker v-model="uploadForm.listDate" reset-button></b-form-datepicker>
            </b-form-group>
          </b-col>

          <b-col cols="md-6" v-if="isFieldSelected('soldDate')">
            <b-form-group label="Sold Date:">
              <b-form-datepicker v-model="uploadForm.soldDate" reset-button></b-form-datepicker>
            </b-form-group>
          </b-col>

          <b-col cols="md-6" v-if="isFieldSelected('listPrice')">
            <b-form-group label="List Price:">
              <b-form-input type="text" v-model="uploadForm.listPrice"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="md-6" v-if="isFieldSelected('listPriceDate')">
            <b-form-group label="List Price Date:">
              <b-form-datepicker v-model="uploadForm.listPriceDate" reset-button></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col cols="md-6" v-if="isFieldSelected('priceBackup')">
            <b-form-group label="Price Backup:">
              <b-form-select v-model="uploadForm.priceBackup" :options="priceBackupOptions"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="md-6" v-if="isFieldSelected('realtor_incentives')">
            <b-form-group label="Realtor Incentives:">
              <b-form-input v-model="uploadForm.realtor_incentives"
                placeholder="Enter realtor incentives"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="md-6" v-if="isFieldSelected('buyer_incentives')">
            <b-form-group label="Buyer Incentives:">
              <b-form-input v-model="uploadForm.buyer_incentives" placeholder="Enter buyer incentives"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" v-if="isFieldSelected('incentivesCalculator')">
            <b-card bg-variant="light" class="mb-3">
              <h6 class="mb-1">Incentives Calculator</h6>
              <p class="small text-muted mb-3">
                Buyer Incentives are calculated per unit from its List Price
                (the List Price entered above, otherwise the unit's current one),
                and replace any Buyer Incentives value. Result =
                List Price &times; months free &divide; total months
                + cash credit &divide; total months, rounded to the nearest dollar.
              </p>
              <b-row>
                <b-col cols="md-6">
                  <b-form-group label="Months free:">
                    <b-form-input type="number" min="0" step="any" v-model="incentivesCalc.monthsFree"
                      placeholder="e.g. 2"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="md-6">
                  <b-form-group label="Total months (free-rent lease term):">
                    <b-form-input type="number" min="0" step="any" v-model="incentivesCalc.freeTotalMonths"
                      placeholder="e.g. 14"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="md-6">
                  <b-form-group label="Total cash credit ($):">
                    <b-form-input type="number" min="0" step="any" v-model="incentivesCalc.cashCredit"
                      placeholder="e.g. 1500"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="md-6">
                  <b-form-group label="Total months (cash credit lease term):">
                    <b-form-input type="number" min="0" step="any" v-model="incentivesCalc.creditTotalMonths"
                      placeholder="e.g. 14"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <div v-if="calculatedIncentives.length" class="small">
                <div class="font-weight-bold mb-1">Preview</div>
                <b-badge variant="vb-secondary" class="mr-1 mb-1" v-for="(row, index) in calculatedIncentives"
                  :key="index">
                  {{ row.unit_number }}: {{ row.incentive === null ? '—' : '$' + row.incentive.toLocaleString() }}
                </b-badge>
              </div>
            </b-card>
          </b-col>

          <b-col cols="md-6" v-if="isFieldSelected('status')">
            <b-form-group label="Status:">
              <b-form-select v-model="uploadForm.status" :options="mlsStatus"></b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="md-6" v-if="isFieldSelected('construction_status')">
            <b-form-group label="Construction Status:">
              <b-form-select v-model="uploadForm.construction_status" :options="constructionStatusOptions"></b-form-select>
            </b-form-group>
          </b-col>

          <b-col cols="md-6" v-if="isFieldSelected('completion_date')">
            <b-form-group label="Construction Completion Date:">
              <b-form-datepicker v-model="uploadForm.completion_date" reset-button></b-form-datepicker>
            </b-form-group>
          </b-col>

          <b-col cols="md-6" v-if="isFieldSelected('close_date')">
            <b-form-group label="Close Date:">
              <b-form-datepicker v-model="uploadForm.close_date" reset-button></b-form-datepicker>
            </b-form-group>
          </b-col>

          <b-col cols="md-6" v-if="isFieldSelected('soldPrice')">
            <b-form-group label="Sold Price:">
              <b-form-input type="text" v-model="uploadForm.soldPrice"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" v-if="isFieldSelected('floorPlan')">
            <b-form-group label="Floor plan upload:">
              <b-form-file v-model="uploadForm.floorPlan" placeholder="Choose floorplan pdf..."></b-form-file>
            </b-form-group>
          </b-col>
        </div>

        <!-- Global Logic -->
        <div v-if="selectedFields.length > 0" class="mt-4 pt-3 border-top">
          <EntryTargetPicker v-if="canChooseEntry" class="mb-3" :target.sync="entryTarget"
            :entry-number.sync="entryNumber" :listings="selectedCids" />
          <div v-else class="d-flex mb-3">
            <b-form-checkbox :checked="entryTarget === 'new'" class="mr-3"
              @change="entryTarget = $event ? 'new' : 'current'">New Entry</b-form-checkbox>
            <b-form-checkbox :checked="entryTarget === 'original'"
              @change="entryTarget = $event ? 'original' : 'current'">Original Entry</b-form-checkbox>
          </div>

          <b-button block variant="vb-primary" size="lg" @click.prevent="mlsUpload"
            :disabled="selectedCids.length === 0 || !entryTargetValid">
            Update {{ selectedCids.length }} Selected Units
          </b-button>
        </div>

        <b-alert v-else show variant="light" class="text-center italic">
          Please select fields from the dropdown above to begin bulk editing.
        </b-alert>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios';
import { BACKEND_URL, isSuperAdmin } from '../../variables';
import { useUserStore } from '../../store/UserStore';
import { useProjectStore } from '../../store/ProjectStore';
import Multiselect from 'vue-multiselect';
import FileUploadCell from '../tabulator_components/FileUploadCell.vue';
import EntryTargetPicker from './EntryTargetPicker.vue';

export default {
  props: {
    selectedCids: { type: Array, required: true },
  },
  components: { Multiselect, FileUploadCell, EntryTargetPicker },
  data() {
    return {
      selectedFields: [],
      // Which entry the update is written to: 'original' | 'current' | 'nth' | 'new'.
      entryTarget: 'current',
      entryNumber: 2,
      fieldOptions: [
        { id: 'actualSize', label: 'Actual Size' },
        { id: 'backupfile', label: 'Backup File' },
        { id: 'balcony', label: 'Balcony' },
        { id: 'balcony_area', label: 'Balcony Area' },
        { id: 'bath', label: 'Baths' },
        { id: 'bed', label: 'Beds' },
        { id: 'buyer_incentives', label: 'Buyer Incentives' },
        { id: 'incentivesCalculator', label: 'Incentives Calculator' },
        { id: 'construction_status', label: 'Construction Status' },
        { id: 'completion_date', label: 'Construction Completion Date' },
        { id: 'close_date', label: 'Close Date' },
        { id: 'fl', label: 'Floor Level' },
        { id: 'floorPlan', label: 'Floor Plan File' },
        { id: 'fp', label: 'FP Specs' },
        { id: 'listPrice', label: 'List Price' },
        { id: 'listPriceDate', label: 'List Price Date' },
        { id: 'listDate', label: 'List Date' },
        { id: 'priceBackup', label: 'Price Backup' },
        { id: 'stalls', label: 'Parking' },
        { id: 'planName', label: 'Plan Name' },
        { id: 'soldPrice', label: 'Sold Price' },
        { id: 'mls_parking', label: 'Stalls' },
        { id: 'status', label: 'Status' },
        { id: 'realtor_incentives', label: 'Realtor Incentives' },
        { id: 'unitSize', label: 'Unit Size' },
        { id: 'orientation', label: 'View Orientation' },
        { id: 'soldDate', label: 'Sold Date' },
      ],
      // Inputs of the Incentives Calculator field; see calculatedIncentives.
      incentivesCalc: { monthsFree: "", freeTotalMonths: "", cashCredit: "", creditTotalMonths: "" },
      uploadForm: {
        planName: "", fp: [], orientation: 11105, unit: "", bed: "", bath: "",
        unitSize: "", actualSize: "", listPrice: "", pr: "", locker: "", gst: "",
        buyer_incentives: "", realtor_incentives: "", // Added
        construction_status: "", completion_date: null, close_date: null,
        status: 11482, soldDate: null, listDate: null, soldDate: null,
        listPriceDate: null, fl: "", floorPlan: null, pid: "", assignment: 0,
        balcony: "", balcony_area: "", // Added
        soldPrice: "", stalls: "", mls_parking: "", backupfile: {
          pending_file: null
        }, priceBackup: ""

      },
      priceBackupOptions: [
        { text: "Select an option", value: "" },
        { text: "Verified", value: "Verified" },
        { text: "Semi-Verified", value: "Semi-Verified" },
        { text: "Educated Estimated", value: "Educated Estimated" },
      ],

      project: null,
      mlsFloorLevel: null,
      mlsFP: null,
      mlsParking: null,
      // { text, value: tid } from api/get_construction_status (vid 85).
      constructionStatusOptions: [{ text: "Select an option", value: "" }],
      mlsStatus: [
        { text: "None", value: 11482 },
        { text: "Active", value: 8197 },
        { text: "Sold", value: 8198 },
        { text: "Unreleased", value: 23440 },
      ],
      mlsOrientation: [
        { text: "None", value: 11105 },
        { text: "East", value: 11033 },
        { text: "North", value: 11030 },
        { text: "North East", value: 11035 },
        { text: "North West", value: 11034 },
        { text: "South", value: 11032 },
        { text: "South East", value: 11037 },
        { text: "South West", value: 11036 },
        { text: "West", value: 11031 },
      ],
    }
  },
  computed: {
    // Buyer Incentives per selected unit, in the order of selectedCids, rounded to
    // the nearest dollar: List Price x months free / total months + cash credit /
    // total months. `incentive` is null when the unit has no usable list price
    // and the free-months part is needed. Empty unless the calculator field is
    // selected.
    calculatedIncentives() {
      if (!this.isFieldSelected('incentivesCalculator')) return [];
      const num = (v) => {
        const n = Number(String(v === null || v === undefined ? "" : v).replace(/[$,\s]/g, ""));
        return Number.isFinite(n) ? n : 0;
      };
      const monthsFree = num(this.incentivesCalc.monthsFree);
      const freeTotal = num(this.incentivesCalc.freeTotalMonths);
      const cash = num(this.incentivesCalc.cashCredit);
      const creditTotal = num(this.incentivesCalc.creditTotalMonths);
      const needsPrice = monthsFree > 0 && freeTotal > 0;
      // A List Price typed in this form wins; it may be a single value or a
      // comma-separated list, one per unit, exactly as the backend reads it.
      const typed = this.isFieldSelected('listPrice')
        ? String(this.uploadForm.listPrice || "").split(",").map((v) => v.trim()).filter((v) => v !== "")
        : [];
      return this.selectedCids.map((item, index) => {
        const raw = typed.length > 1 ? typed[index] : typed.length === 1 ? typed[0] : item.listPrice;
        const price = num(raw);
        let total = 0;
        if (needsPrice) total += (price * monthsFree) / freeTotal;
        if (cash > 0 && creditTotal > 0) total += cash / creditTotal;
        const incentive = needsPrice && !(price > 0) ? null : Math.round(total);
        return { unit_number: item.unit_number, incentive };
      });
    },
    // The entry picker (Original / Current / Entry number / New) is super-admin
    // only; admins keep the plain New Entry / Original Entry checkboxes. The
    // backend re-checks entryNumber.
    canChooseEntry() {
      return isSuperAdmin(useUserStore().getUser());
    },
    effectiveEntryTarget() {
      return this.entryTarget === 'nth' && !this.canChooseEntry ? 'current' : this.entryTarget;
    },
    // 'Entry number' needs a whole number >= 1; the other targets need nothing.
    entryTargetValid() {
      return this.effectiveEntryTarget !== 'nth' || (Number.isInteger(Number(this.entryNumber)) && Number(this.entryNumber) >= 1);
    },
  },
  methods: {
    isFieldSelected(fieldId) {
      return this.selectedFields.some(f => f.id === fieldId);
    },
    handleBackupFile(file) {
      this.uploadForm.backupfile.pending_file = file;

      console.log("File staged for upload:", file.name);
    },
    loadFpOptions() {
      const projectStore = useProjectStore();

      // Reuse options already cached in the store (e.g. loaded by UTC.vue).
      if (Array.isArray(projectStore.mlsFP) && projectStore.mlsFP.length) {
        this.mlsFP = projectStore.mlsFP;
        this.mlsParking = projectStore.mlsParking;
        this.mlsFloorLevel = projectStore.mlsFloorLevel;
        return;
      }

      // Otherwise fetch them ourselves so BulkUpload works regardless of parent.
      $.get(
        { url: `${BACKEND_URL}api/get_fp_specs` },
        (data, status) => {
          if (status === "success") {
            this.mlsFP = data.fp_specs;
            this.mlsParking = data.parking;
            this.mlsFloorLevel = data.floor_level;
            projectStore.setOptions({
              mlsFp: data.fp_specs,
              mlsParking: data.parking,
              mlsFloorLevel: data.floor_level,
            });
          }
        }
      ).fail(() => {
        console.error("BulkUpload: failed to load FP specs options");
      });
    },
    async fetchConstructionStatuses() {
      try {
        const { data } = await axios.get(`${BACKEND_URL}api/get_construction_status`);
        const options = (Array.isArray(data) ? data : [])
          .filter((d) => d && d.id && d.label)
          .map((d) => ({ text: String(d.label), value: String(d.id) }));
        this.constructionStatusOptions = [{ text: "Select an option", value: "" }, ...options];
      } catch (e) {
        console.error("BulkUpload: failed to load construction statuses", e);
      }
    },
    mlsUpload() {
      const vm = this;
      let formData = new FormData();

      formData.append("uid", this.$route.query.uid);
      formData.append("cids", JSON.stringify(this.selectedCids.map(item => item.cid)));

      // Base fields
      formData.append("planName", this.uploadForm.planName);
      formData.append("fp", this.uploadForm.fp.map(el => el.value));
      formData.append("fl", this.uploadForm.fl);
      formData.append("orientation", this.uploadForm.orientation);
      formData.append("bed", this.uploadForm.bed);
      formData.append("bath", this.uploadForm.bath);
      formData.append("unitSize", this.uploadForm.unitSize);
      formData.append("actualSize", this.isFieldSelected('actualSize') ? this.uploadForm.actualSize : "");
      formData.append("listPrice", this.uploadForm.listPrice);
      formData.append("status", this.uploadForm.status);
      formData.append("soldPrice", this.uploadForm.soldPrice);
      formData.append("files", this.uploadForm.floorPlan);
      formData.append("listPriceDate", this.uploadForm.listPriceDate);
      formData.append("listDate", this.uploadForm.listDate);
      formData.append("soldDate", this.uploadForm.soldDate);

      formData.append("realtorIncentives", this.uploadForm.realtor_incentives);
      // The calculator overrides Buyer Incentives with one value per unit; the
      // backend reads a comma-separated list by position in `cids`.
      formData.append("buyerIncentives", this.isFieldSelected('incentivesCalculator')
        ? this.calculatedIncentives.map((row) => (row.incentive === null ? 0 : row.incentive)).join(",")
        : this.uploadForm.buyer_incentives);
      formData.append("pr", this.uploadForm.stalls);
      formData.append("parking", this.uploadForm.mls_parking);
      formData.append("balconyArea", this.uploadForm.balcony_area);
      formData.append("balcony", this.uploadForm.balcony);
      formData.append("priceBackup", this.uploadForm.priceBackup);
      // Only a selected, non-empty status goes out: the backend writes any posted
      // construction_status onto the entry, so an untouched one must not be sent.
      if (this.isFieldSelected('construction_status') && this.uploadForm.construction_status) {
        formData.append("construction_status", this.uploadForm.construction_status);
      }
      // Unit-level dates (YYYY-MM-DD from the picker); same rule: only when selected and set.
      ['completion_date', 'close_date'].forEach((key) => {
        if (this.isFieldSelected(key) && this.uploadForm[key]) formData.append(key, this.uploadForm[key]);
      });

      formData.append("newEntry", this.effectiveEntryTarget === 'new' ? 1 : 0);
      formData.append("originalEntry", this.effectiveEntryTarget === 'original' ? 1 : 0);
      if (this.effectiveEntryTarget === 'nth') formData.append("entryNumber", Math.floor(Number(this.entryNumber)));
      if (this.uploadForm.backupfile && this.uploadForm.backupfile.pending_file) {
        formData.append("backupfile", this.uploadForm.backupfile.pending_file);
      }

      vm.$bvToast.toast(`Updating ${this.selectedCids.length} listings...`, {
        title: "Uploading data...",
        variant: "info",
      });

      $.ajax({
        type: "POST",
        url: `${BACKEND_URL}api/presale_mls_bulk_update`,
        data: formData,
        processData: false,
        contentType: false,
      })
        .done((response) => {
          vm.$bvToast.toast(`Bulk update successful!`, {
            title: "Success",
            variant: "success",
          });

          this.uploadForm.backupfile.pending_file = null;
          this.$emit("saved", response);
        })
        .fail(() => {
          vm.$bvToast.toast(`Update failed.`, {
            title: "Error",
            variant: "danger",
          });
        });
    }
  },
  mounted() {
    const projectStore = useProjectStore();
    this.project = projectStore.project;
    this.loadFpOptions();
    this.fetchConstructionStatuses();
  }
}
</script>
